import { queryOptions } from '@tanstack/react-query'
import { getUser, getUsers } from 'User/api/UserApi'

import { RequestStaleTime } from 'Common/utils/helpers/HelperQuery'

export const userQueries = {
    all: () => ['users'],
    lists: () => [...userQueries.all(), 'list'],
    list: () =>
        queryOptions({
            queryKey: [...userQueries.lists()],
            queryFn: () => getUsers(),
            staleTime: RequestStaleTime.default,
        }),
    details: () => [...userQueries.all(), 'detail'],
    detail: (id: string) =>
        queryOptions({
            queryKey: [...userQueries.details(), id],
            queryFn: () => getUser(id),
            staleTime: RequestStaleTime.default,
        }),
}
